module.exports = __webpack_public_path__ + "img/table.3de1b111.svg";